import React from "react";
import VIPOLoading from "Assets/Img/vipo-loading.json";
import VIPPLoading from "Assets/Img/vipp-loading.json";
import VIPGenericLoading from "Assets/Img/vip-generic-loading.json";
import { PRODUCTTYPES } from "Utils/Constants";
import VIPPreferredLogo from "Assets/Img/vipp-logo.png";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import useSession from "Utils/Hooks/useSession";
import { Box, CircularProgress } from "@mui/material";

/**
 *
 * @param {Loading.defaultProps} props
 * @returns
 */
const Loading = (props) => {
  const { session } = useSession();
  const { height } = { height: 200, ...props };
  const { width } = { width: 200, ...props };
  const { isEnrollment } = { isEnrollment: false, ...props };

  const isVIPPreferred = session?.productType === PRODUCTTYPES.PREFERRED;
  const productType = isVIPPreferred ? "VIP Preferred" : "VIP Online";
  const logoSrc = isVIPPreferred ? VIPPreferredLogo : VIPOnlineLogo;
  var loadingLogo = VIPGenericLoading;
  if (session?.productType) {
    if (session.productType === session.patronProductType) {
      loadingLogo =
        session.productType === PRODUCTTYPES.PREFERRED
          ? VIPPLoading
          : VIPOLoading;
    }
  }
  const animProps = {
    animationData: isEnrollment ? VIPGenericLoading : loadingLogo,
    height: height,
    width: width,
    style: props.style,
    isLoop: true,
  };

  return (
    <Box
      sx={{
        display: "flex",
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        alignItems: "center",
        justifyContent: "center",
        background: "rgb(255, 255, 255)",
        zIndex: 1,
      }}
    >
      <CircularProgress size="100px" thickness={2.5} />
    </Box>
  );
};
export default Loading;
